import api from "./api";
import { BOUNCER_APP_NAME, ALL_PERMISSION_KEYS } from "../constants/bouncerPermissions";

const BOUNCER_URL = "/infra/auth/api/v3/users/check-access";

/**
 * Fetches the current user's permissions from Bouncer in a single call.
 * Returns an array of allowed permission key strings.
 *
 * @returns {Promise<string[]>} e.g. ["FULFILMENT_ACCOUNTS_PAYABLE_INVOICE_MANAGEMENT_VIEW", "FULFILMENT_ACCOUNTS_PAYABLE_INVOICE_EDIT"]
 */
export async function fetchBouncerPermissions() {
  const response = await api.post(
    BOUNCER_URL,
    { application_name: BOUNCER_APP_NAME, permissions: ALL_PERMISSION_KEYS },
    { useTarsToken: false, baseURL: window.config.REACT_APP_AUTH_GATEWAY || window.config.REACT_APP_APIGATEWAY }
  );

  // Response: { "FULFILMENT_ACCOUNTS_PAYABLE_INVOICE_MANAGEMENT_VIEW": "allow", "..._INVOICE_EDIT": "deny", ... }
  return Object.entries(response)
    .filter(([, status]) => status === "allow")
    .map(([key]) => key);
}
